interface LeadsNurturedIconProps {
   width?: number
   height?: number
   className?: string
   fill?: string
}

export const LeadsNurturedIcon = ({
   width = 24,
   height = 24,
   className = '',
   fill = '#AB7AE0',
}: LeadsNurturedIconProps) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width={width}
         height={height}
         viewBox="0 0 24 24"
         fill="none"
         className={className}
      >
         <g clipPath="url(#clip0_7327_566)">
            <path
               d="M12 24C5.383 24 0 18.617 0 12C0 5.383 5.383 0 12 0C18.617 0 24 5.383 24 12C24 18.617 18.617 24 12 24ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 6C8.691 6 6 8.691 6 12C6 15.309 8.691 18 12 18C15.309 18 18 15.309 18 12C18 8.691 15.309 6 12 6ZM12 16C9.794 16 8 14.206 8 12C8 9.794 9.794 8 12 8C14.206 8 16 9.794 16 12C16 14.206 14.206 16 12 16ZM12 10C10.897 10 10 10.897 10 12C10 13.103 10.897 14 12 14C13.103 14 14 13.103 14 12C14 10.897 13.103 10 12 10Z"
               fill={fill}
            />
         </g>
         <defs>
            <clipPath id="clip0_7327_566">
               <rect width="24" height="24" fill="white" />
            </clipPath>
         </defs>
      </svg>
   )
}
